import useSWR from 'swr';

import { readDocumentReaderUploadFiles } from './readDocumentReaderUploadFiles';
import type {
  IDocumentReaderUploadFilesState,
  IDocumentReaderUploadReference,
  TDocumentReaderUploadFilesKey,
} from './types';

/** The files of a sent data room with their names, read once to draw the room on its chat message. A
 * sent room never changes, so it is not asked for again. */
export function useDocumentReaderUploadFiles(
  dataRoom: IDocumentReaderUploadReference | null
): IDocumentReaderUploadFilesState {
  const key: TDocumentReaderUploadFilesKey | null = dataRoom
    ? ['document-reader-upload-files', dataRoom.uploadId, dataRoom.fileCount]
    : null;
  const { data, isLoading, error } = useSWR(
    key,
    ([, uploadId, fileCount]: TDocumentReaderUploadFilesKey) =>
      readDocumentReaderUploadFiles(uploadId, fileCount),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      shouldRetryOnError: false,
    }
  );

  return {
    uploadFiles: error ? null : (data ?? null),
    isLoading: dataRoom !== null && isLoading,
    error,
  };
}
